<template>
  <div class="ai-toolbar-wrapper">
    <!-- 获取客户信息返回值 -->
    <div v-if="!isYuewanLocation()" class="ai-toolbar-container">
      <div class="search-panel">
        <div class="panel-header" @click="toggleSearchPanel">
          <h4>筛选条件</h4>
          <i class="el-icon-arrow-down collapse-icon" :class="{ collapsed: !showSearchPanel }"></i>
        </div>
        <div class="date-picker" v-show="showSearchPanel">
          <div class="date-item">
            <el-date-picker v-model="pay_begin_time" type="date" placeholder="区间付费开始时间"></el-date-picker>
          </div>
          <div class="date-item">
            <el-date-picker v-model="pay_end_time" type="date" placeholder="区间付费结束时间"></el-date-picker>
          </div>
          <div class="date-item">
            <el-date-picker v-model="app_pay_begin_time" type="date" placeholder="转端包付费开始时间"></el-date-picker>
          </div>
          <div class="date-item">
            <el-date-picker v-model="app_pay_end_time" type="date" placeholder="转端包付费结束时间"></el-date-picker>
          </div>
          <div class="date-item">
            <el-input v-model="user_id" placeholder="用户ID"></el-input>
          </div>
          <div class="date-item">
            <el-input v-model="user_name" placeholder="用户名"></el-input>
          </div>
          <div class="date-item">
            <label class="radio-label">是否绑定用户(勾选是将绑定查询用户):</label>
            <el-radio-group v-model="bind_user">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
          <el-button type="primary" @click="getList">查询</el-button>
        </div>
      </div>

      <div class="info-header">
        <h3>客户信息</h3>
      </div>

      <div class="user-info-container" v-for="item in userInfo" :key="item.user_id">
        <el-card class="user-card">
          <!-- 基本信息 -->
          <div class="user-basic-info">
            <h4>基本信息</h4>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">用户ID:</span> 
                <span class="value">{{ item.user_id }}</span>
              </div>
              <div class="info-item">
                <span class="label">用户名称:</span> 
                <span class="value">{{ item.user_name }}</span>
              </div>
              <div class="info-item">
                <span class="label">注册游戏:</span> 
                <span class="value">{{ item.register_app_name }}</span>
              </div>
              <div class="info-item">
                <span class="label">类型:</span> 
                <span class="value">{{ item.type }} (1 代表小游戏)</span>
              </div>
              <div class="info-item" v-if="item.os_list && item.os_list.length > 0">
                <span class="label">系统:</span> 
                <span class="value">
                  <el-tag v-for="os in item.os_list" :key="os" size="small" style="margin-right: 5px;">
                    {{ os }}
                  </el-tag>
                </span>
              </div>
              <div class="info-item">
                <span class="label">绑定状态:</span> 
                <div class="bind-status-container">
                  <el-tag :type="getBindStatusType(item.bind_status)" size="small">
                    {{ getBindStatusText(item.bind_status) }}
                  </el-tag>
                  <el-popover
                    v-if="item.bind_status !== 2"
                    :ref="`popover-${item.user_id}`"
                    placement="top"
                    width="200"
                    trigger="click"
                    popper-class="bind-confirm-popover"
                  >
                    <div class="bind-confirm-content">
                      <p>确认要{{ item.bind_status === 0 ? '绑定' : '解绑' }}该用户吗？</p>
                      <div class="confirm-buttons">
                        <el-button size="mini" type="text" @click="closePopover(item.user_id)">取消</el-button>
                        <el-button type="primary" size="mini" @click="confirmBindAction(item)">确定</el-button>
                      </div>
                    </div>
                    <el-button 
                      slot="reference"
                      :type="item.bind_status === 0 ? 'primary' : 'danger'"
                      size="mini"
                      style="margin-left: 10px;margin-top: -12px;"
                    >
                      {{ item.bind_status === 0 ? '绑定' : '解绑' }}
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>

          <el-divider></el-divider>

          <!-- 付费信息 -->
          <div class="user-payment-info">
            <h4>付费信息</h4>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">用户总充值:</span> 
                <span class="value highlight-amount">¥{{ item.total_payment || 0 }}</span>
              </div>
            </div>
          </div>
          <template v-if="item.package_switch_info">
            <el-divider></el-divider>
            <div class="user-package-switch-info">
              <div class="package-title-row">
                <h4>切包信息</h4>
                <el-tag size="mini" :type="item.package_switch_info.strategy_status === 'CONFIGURED' ? 'success' : 'info'">
                  {{ item.package_switch_info.strategy_status === 'CONFIGURED' ? '已配置策略' : '未配置策略' }}
                </el-tag>
              </div>
              <div v-if="isWeChatMiniGame(item)" class="info-grid package-user-facts">
                <div class="info-item"><span class="label">最高充值角色名:</span><span class="value">{{ item.package_switch_info.highest_pay_role_name || '无' }}</span></div>
                <div class="info-item"><span class="label">最高充值角色ID:</span><span class="value">{{ item.package_switch_info.highest_pay_role_id || '无' }}</span></div>
                <div class="info-item">
                  <span class="label">玩家一审是否可切:</span>
                  <span class="value"><el-tag size="small" :type="getAuditType(item.package_switch_info.lead_audit)">{{ getAuditText(item.package_switch_info.lead_audit) }}</el-tag></span>
                </div>
                <div class="info-item">
                  <span class="label">180天内登录过iOS设备:</span>
                  <span class="value"><el-tag size="small" :type="getStatusType(item.package_switch_info.ios_login_status)">{{ getStatusText(item.package_switch_info.ios_login_status) }}</el-tag></span>
                </div>
                <div class="info-item">
                  <span class="label">是否登录过转端包:</span>
                  <span class="value"><el-tag size="small" :type="getStatusType(item.package_switch_info.transfer_package_login_status)">{{ getStatusText(item.package_switch_info.transfer_package_login_status) }}</el-tag></span>
                </div>
              </div>
              <el-alert v-if="item.package_switch_info.strategy_status === 'NOT_CONFIGURED'" title="当前注册子游戏暂未配置切包策略" type="info" :closable="false" show-icon></el-alert>
              <div v-else class="strategy-detail">
                <div class="info-grid">
                  <div class="info-item"><span class="label">项目:</span><span class="value">{{ item.package_switch_info.project_name || '无' }}</span></div>
                  <div class="info-item"><span class="label">合同游戏:</span><span class="value">{{ item.package_switch_info.tag_name || '无' }}</span></div>
                  <div class="info-item"><span class="label">子游戏:</span><span class="value">{{ item.package_switch_info.app_name || '无' }}</span></div>
                  <div class="info-item full-row"><span class="label">切包调整:</span><span class="value multiline">{{ item.package_switch_info.package_adjustment || '无' }}</span></div>
                  <div class="info-item full-row"><span class="label">切包条件:</span><span class="value multiline">{{ item.package_switch_info.package_condition || '无' }}</span></div>
                  <div class="info-item full-row"><span class="label">切包流程:</span><span class="value multiline">{{ item.package_switch_info.package_process || '无' }}</span></div>
                  <div class="info-item full-row"><span class="label">切包备注:</span><span class="value multiline">{{ item.package_switch_info.package_remark || '无' }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-card>
      </div>

      <!-- 角色信息 -->
      <div v-if="roleInfo && roleInfo.length > 0" class="role-section">
        <div class="info-header">
          <h3>角色信息</h3>
        </div>
        <div class="role-info-container" v-for="role in roleInfo" :key="role.role_id">
          <el-card class="role-card">
            <div class="role-basic-info">
              <h4>{{ role.role_name }} (角色id：{{ role.role_id }})</h4>
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">创角游戏:</span> 
                  <span class="value">{{ role.pname }}</span>
                  <span class="value">appkey {{ role.appkey }}</span>
                </div>
                <div class="info-item">
                  <span class="label">角色创建时间:</span> 
                  <span class="value">{{ role.role_create_time || '无' }}</span>
                </div>
                <div class="info-item">
                  <span class="label">服务器:</span> 
                  <span class="value">名称：{{ role.server_name }} id：{{ role.server_id }}</span>
                  <span class="value">开服：{{ role.days_since_launch }}天 合服：{{ role.server_merge_count }}次 合服：{{ role.days_since_last_merge }}天</span>
                </div>
                <div class="info-item">
                  <span class="label">最后进入游戏:</span> 
                  <span class="value">{{ role.role_last_enter_app_name }}</span>
                  <span class="value">appkey {{ role.role_last_enter_appkey }}</span>
                </div>
                <div class="info-item">
                  <span class="label">最后进入时间:</span> 
                  <span class="value">{{ role.role_last_enter_time || '无' }}</span>
                </div>
              </div>
            </div>

            <el-divider></el-divider>

            <div class="role-payment-info">
              <h5>付费信息</h5>
              <div class="payment-stats">
                <div class="payment-item">
                  <div class="payment-label">角色充值</div>
                  <div class="payment-value">¥{{ role.role_pay || 0 }}</div>
                </div>
                <div class="payment-item">
                  <div class="payment-label">转移包充值</div>
                  <div class="payment-value">¥{{ role.role_pay_in_app || 0 }}</div>
                </div>
                <div class="payment-item">
                  <div class="payment-label">角色期内充值</div>
                  <div class="payment-value">¥{{ role.period_role_pay || 0 }}</div>
                </div>
                <div class="payment-item">
                  <div class="payment-label">角色转移包期内充值</div>
                  <div class="payment-value">¥{{ role.period_role_pay_in_app || 0 }}</div>
                </div>
              </div>
              <div class="info-grid" style="margin-top: 10px;">
                <div class="info-item">
                  <span class="label">角色最后付费时间:</span> 
                  <span class="value">{{ role.role_last_pay_time }}</span>
                </div>
                <div class="info-item">
                  <span class="label">最后付费游戏:</span> 
                  <span class="value">{{ role.role_last_pay_app_name }}</span>
                  <span class="value">appkey {{ role.role_last_pay_appkey }}</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 投诉信息 -->
      <div v-if="complaintInfo && complaintInfo.length > 0" class="complaint-section">
        <div class="info-header">
          <h3>投诉信息</h3>
        </div>
        <el-card class="complaint-card">
          <div class="complaint-stats">
            <div class="complaint-item" v-for="complaint in complaintInfo" :key="complaint.type">
              <div class="complaint-type">{{ complaint.type }}</div>
              <div class="complaint-count">{{ complaint.count }}次</div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<!-- <script src="//wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.0.2.js"></script> -->
<script>
import request from '@/utils/request';
// import vConsole from 'vconsole';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import { isYuewanLocation } from '@/config';

// new vConsole();

const getEnv = function () {
  if (process.env.NODE_ENV === 'development') {
    return '//h5.hzwxbz999.cn'; // 乐缜 企微域名，测试直接使用生产域名加本地代理 worksn-manage.hzlz123.cn
  } else {
    switch (window.location.hostname) { 
      case 'worksntest.hzwxbz999.cn':
      case 'worksn-manage-test.1uoang.cn':
        return '//h5test.hzwxbz999.cn';
      case 'worksnpre.hzwxbz999.cn':
      case 'worksn-manage-pre.1uoang.cn':
      case 'worksn-manage-pre.hzlz123.cn':
        return '//h5.hzwxbz999.cn';
      case 'worksn-manage.lingchan521.cn':
        return '//h5.lingchan521.cn';
      case 'worksn-manage.hzkl521.cn':
        return '//h5.hzkl521.cn';
      case 'worksn-manage.qyou22.cn':
        return '//h5.qyou22.cn';
      case 'worksn-manage.1uoang.cn':
        return '//h5.1uoang.cn';
      default:
        return '//h5.hzlz123.cn';
    }
  }
};

export default {
  name: 'aiToolbar',
  data() {
    return {
      userId: '',
      userInfo: '',
      roleInfo: '',
      complaintInfo: '',
      corpid: 'ww5abbef484e38d107',
      agentid: 1000002,
      pay_begin_time: '',
      pay_end_time: '',
      app_pay_begin_time: '',
      app_pay_end_time: '',
      user_id: '',
      user_name: '',
      bind_user: false, // 是否绑定用户(勾选后查询绑定用户)
      showSearchPanel: true, // 控制筛选面板显示隐藏
      auditPollingTimer: null, // 审核状态轮询定时器
      auditPollingCount: 0, // 单次查询最多轮询 5 次
    };
  },
  mounted() {
    const { corpid, agentid } = this.$route.query;
    if (corpid) {
      this.corpid = corpid;
    }
    if (agentid) {
      this.agentid = agentid;
    }
    // 非悦玩的时候再加载企微sdk
    if (!isYuewanLocation()) {
      this.loadScripts();
    }
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    if (this.auditPollingTimer) {
      clearInterval(this.auditPollingTimer);
      this.auditPollingTimer = null;
    }
  },
  methods: {
    isYuewanLocation, // 将导入的函数暴露给模板使用
    // 切换筛选面板显示状态
    toggleSearchPanel() {
      this.showSearchPanel = !this.showSearchPanel;
    },
    // 获取审核状态类型
    getAuditType(status) {
      switch (status) {
        case 0: return '';
        case 1: return 'success';
        case 2: return 'warning';
        default: return 'info';
      }
    },
    // 获取审核状态文本
    getAuditText(status) {
      switch (status) {
        case 0: return '否';
        case 1: return '是';
        case 2: return '请求数据中';
        default: return '未知';
      }
    },
    isWeChatMiniGame(user) {
      return user.register_game_business_type === 'weixinxiaoyouxi';
    },
    getStatusType(status) {
      if (status === 'YES') return 'success';
      if (status === 'NO') return 'info';
      return 'warning';
    },
    getStatusText(status) {
      if (status === 'YES') return '是';
      if (status === 'NO') return '否';
      return '未知';
    },
    needsAuditPolling(user) {
      return this.isWeChatMiniGame(user)
        && user.package_switch_info
        && user.package_switch_info.lead_audit === 2;
    },
    stopAuditPolling() {
      if (this.auditPollingTimer) {
        clearInterval(this.auditPollingTimer);
        this.auditPollingTimer = null;
      }
    },
    // 获取绑定状态类型
    getBindStatusType(status) {
      switch (status) {
        case 0: return 'info'; // 未绑定
        case 1: return 'success'; // 已绑定
        case 2: return 'success'; // 已绑定且不可解绑
        default: return 'info';
      }
    },
    // 获取绑定状态文本
    getBindStatusText(status) {
      switch (status) {
        case 0: return '未绑定';
        case 1: return '已绑定';
        case 2: return '已绑定';
        default: return '未知';
      }
    },
    // 关闭弹出框
    closePopover(userId) {
      // 如果提供了 userId，关闭特定的 popover
      if (userId) {
        const popoverRef = this.$refs[`popover-${userId}`];
        if (popoverRef && popoverRef[0]) {
          popoverRef[0].doClose();
        }
      } else {
        // 关闭所有打开的 popover
        const popovers = document.querySelectorAll('.el-popover');
        popovers.forEach(popover => {
          if (popover.style.display !== 'none') {
            popover.style.display = 'none';
          }
        });
      }
    },
    
    // 确认绑定/解绑操作
    async confirmBindAction(user) {
      const isBinding = user.bind_status === 0;
      const actionText = isBinding ? '绑定' : '解绑';
      
      try {
        // 调用绑定/解绑接口
        const res = await request({
          url: `${getEnv()}/qy-weixin/program/external-user-bind`,
          method: 'post',
          data: this.sort_ASCII({
            corpid: this.corpid,
            external_userid: this.userId,
            // corpid: "wwb0a0a5671ebe63fb",
            // external_userid: "wmSpKeRQAA4PPfkfPfnJHIcDuPZkwRwg",
            user_id: user.user_id,
            type: isBinding ? 'bind' : 'remove'
          }),
        });

        // 更新本地状态
        user.bind_status = isBinding ? 1 : 0;
        this.$message.success(`${actionText}成功`);
        
        // 关闭弹出框
        this.closePopover(user.user_id);
      } catch (error) {
        console.error(`${actionText}用户失败:`, error);
        this.$message.error(`${actionText}失败`);
      }
    },
    loadScripts() {
      const captchaScript = document.createElement('script');
      captchaScript.type = 'text/javascript';
      captchaScript.src = '//wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.0.2.js';

      // 在验证码脚本加载完成后初始化验证码
      captchaScript.onload = () => {
        this.wxRegister();
      };

      document.head.appendChild(captchaScript);
    },
    wxRegister() {
      ww.register({
        corpId: this.corpid, // 必填，当前用户企业所属企业ID
        agentId: this.agentid, // 必填，当前应用的AgentID
        jsApiList: ['getCurExternalContact', 'getContext'], // 必填，需要使用的JSAPI列表
        // getConfigSignature: async () => {
        //   return { timestamp, nonceStr, signature }
        // },                // 必填，根据url生成企业签名的回调函数
        getAgentConfigSignature: async (url) => {
          console.log('当前域名', window.location.hostname);
          console.log('请求签名接口', `${getEnv()}/qy-weixin/program/signature`);
          console.log(
            '请求签名参数',
            this.sort_ASCII({
              url: url,
              corpid: this.corpid,
            }),
          );
          const res = await request({
            url: `${getEnv()}/qy-weixin/program/signature`,
            method: 'post',
            data: this.sort_ASCII({
              url: url,
              corpid: this.corpid,
            }),
          });
          console.log('请求签名返回', res);
          const { timestamp, nonce_str, signature } = res.data.content;
          return { timestamp, nonceStr: nonce_str, signature };
        },
      });
      ww.getCurExternalContact({
        success: (res) => {
          console.log('获取当前客户ID', res.userId);
          this.userId = res.userId;
          this.getList();
        },
        fail(err) {
          console.log('获取当前客户信息失败', err);
        },
      });
    },
    async getList() {
      const params = {
        corpid: this.corpid,
        external_userid: this.userId,
        // corpid: "wwb0a0a5671ebe63fb",
        // external_userid: "wmSpKeRQAA4PPfkfPfnJHIcDuPZkwRwg",
        pay_begin_time: this.pay_begin_time ? moment(this.pay_begin_time).format('YYYY-MM-DD') : undefined,
        pay_end_time: this.pay_end_time ? moment(this.pay_end_time).format('YYYY-MM-DD') : undefined,
        app_pay_begin_time: this.app_pay_begin_time ? moment(this.app_pay_begin_time).format('YYYY-MM-DD') : undefined,
        app_pay_end_time: this.app_pay_end_time ? moment(this.app_pay_end_time).format('YYYY-MM-DD') : undefined,
        user_id: this.user_id || undefined,
        user_name: this.user_name || undefined,
        bind_user: this.bind_user ? true : false,
      }
      // 过滤掉值为undefined的参数
      Object.keys(params).forEach(key => {
        if (params[key] === undefined) {
          delete params[key];
        }
      });
      console.log('获取客户信息', this.sort_ASCII(params));
      const res = await request({
        url: `${getEnv()}/qy-weixin/program/external-user-info`,
        method: 'post',
        data: this.sort_ASCII(params),
      });
      console.log('获取客户信息结果', res);
      
      // 根据新的数据结构处理返回值
      const content = res.data.content;
      // 合并玩心和悦玩用户数据，并过滤掉可能存在的 null 值
      const wanxinUsers = (content.user_data_list || []).filter(Boolean);
      const yuewanUsers = (content.yuewan_user_data_list || []).filter(Boolean);
      this.userInfo = [...wanxinUsers, ...yuewanUsers];
      if (this.userInfo.length > 0) {
       this.showSearchPanel = !this.showSearchPanel;
      }
      // 从所有用户中提取角色信息
      this.roleInfo = [];
      if (this.userInfo && this.userInfo.length > 0) {
        this.userInfo.forEach(user => {
          if (user.role_data_list && user.role_data_list.length > 0) {
            this.roleInfo = this.roleInfo.concat(user.role_data_list);
          }
        });
      }
      
      this.complaintInfo = content.complaint_list || [];
      
      console.log('获取客户信息结果', {
        userInfo: this.userInfo,
        roleInfo: this.roleInfo,
        complaintInfo: this.complaintInfo
      });
      
      // 检查是否需要轮训审核状态
      this.checkAndStartAuditPolling();
    },
    // 生成参数签名
    sort_ASCII(obj) {
      let arr = [];
      let num = 0;
      const secret = 'TKGKItgT';
      for (let i in obj) {
        arr[num] = i;
        num++;
      }
      let sortArr = arr.sort();
      sortArr = sortArr.map((item) => {
        return `${item}=${obj[item]}`;
      });
      let sortString = `${sortArr.join('&')}${secret}`;
      return {
        ...obj,
        sign: CryptoJS.MD5(sortString).toString().toLowerCase(),
      };
    },
    async refreshAudit(user_id) {
      const res = await request({
        url: `${getEnv()}/qy-weixin/program/refresh-audit`,
        method: 'post',
        data: this.sort_ASCII({
          user_id: user_id,
        }),
      });
      return res.data.content.lead_audit;
    },
    checkAndStartAuditPolling() {
      this.stopAuditPolling();
      this.auditPollingCount = 0;
      const usersNeedPolling = this.userInfo.filter(user => this.needsAuditPolling(user));
      if (usersNeedPolling.length > 0) {
        this.auditPollingTimer = setInterval(() => this.pollAuditStatus(), 20000);
      }
    },
    async pollAuditStatus() {
      const usersNeedPolling = this.userInfo.filter(user => this.needsAuditPolling(user));
      if (usersNeedPolling.length === 0 || this.auditPollingCount >= 5) {
        this.stopAuditPolling();
        return;
      }
      this.auditPollingCount += 1;
      for (const user of usersNeedPolling) {
        try {
          const newAuditStatus = await this.refreshAudit(user.user_id);
          this.userInfo.filter(item => item.user_id === user.user_id).forEach(item => {
            item.lead_audit = newAuditStatus;
            if (item.package_switch_info) item.package_switch_info.lead_audit = newAuditStatus;
          });
        } catch (error) {
          console.error(`轮询用户${user.user_id}审核状态失败:`, error);
        }
      }
      if (!this.userInfo.some(user => this.needsAuditPolling(user)) || this.auditPollingCount >= 5) {
        this.stopAuditPolling();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-toolbar-wrapper {
  width: 360px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.ai-toolbar-container {
  padding: 15px;
  background-color: #f5f7fa;
  min-height: 100%;

  .search-panel {
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      user-select: none;

      h4 {
        margin: 0;
        font-size: 16px;
        color: #303133;
      }

      .collapse-icon {
        transition: transform 0.3s ease;
        
        &.collapsed {
          transform: rotate(-90deg);
        }
      }
    }

    .date-picker {
      padding: 15px;
      display: flex;
      flex-direction: column;

      .date-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        span {
          margin-bottom: 5px;
          white-space: nowrap;
        }

        .el-date-editor {
          width: 100%;
        }

        .radio-label {
          font-size: 14px;
          color: #606266;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .el-radio-group {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .el-radio {
            margin-right: 0;
            
            .el-radio__label {
              font-size: 13px;
            }
          }
        }
      }

      .el-button {
        width: 100%;
        margin-top: 5px;
      }
    }
  }

  .info-header {
    margin-bottom: 15px;

    h3 {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
      margin: 0;
    }
  }

  .user-info-container, .role-section, .complaint-section {
    margin-bottom: 15px;

    .user-card, .role-card, .complaint-card {
      border-radius: 8px;

      h4 {
        font-size: 16px;
        margin-top: 0;
        margin-bottom: 15px;
        color: #409eff;
      }

      h5 {
        font-size: 14px;
        margin: 0 0 10px 0;
        color: #606266;
        font-weight: 600;
      }

      .info-grid {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .info-item {
          display: flex;
          flex-direction: column;

          .label {
            color: #606266;
            font-weight: 500;
            margin-bottom: 3px;
            font-size: 13px;
          }

          .value {
            color: #303133;
            word-break: break-all;
            font-size: 12px;
          }

          .highlight-amount {
            color: #e6a23c;
            font-weight: 600;
            font-size: 14px;
          }

          .bind-status-container {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 5px;
          }
        }
      }

      .el-divider {
        margin: 15px 0;
      }
    }
  }

  // 角色付费信息样式
  .payment-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 10px;

    .payment-item {
      background: #f8f9ff;
      border-radius: 6px;
      padding: 10px;
      text-align: center;

      .payment-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 5px;
      }

      .payment-value {
        font-size: 12px;
        font-weight: 600;
        color: #409eff;
      }
    }
  }

  // 投诉信息样式
  .complaint-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .complaint-item {
      background: #fff2f0;
      border: 1px solid #ffccc7;
      border-radius: 6px;
      padding: 10px 15px;
      text-align: center;
      min-width: 100px;

      .complaint-type {
        font-size: 13px;
        color: #cf1322;
        margin-bottom: 5px;
      }

      .complaint-count {
        font-size: 13px;
        font-weight: 600;
        color: #ff4d4f;
      }
    }
  }

  .role-info-container {
    margin-bottom: 10px;

    .role-card {
      .role-basic-info h4 {
        color: #52c41a;
        border-left: 4px solid #52c41a;
        padding-left: 10px;
      }
    }
  }

  // 弹出框确认操作样式
  .bind-confirm-popover {
    .bind-confirm-content {
      text-align: center;
      
      p {
        margin: 0 0 15px 0;
        color: #606266;
        font-size: 14px;
      }
      
      .confirm-buttons {
        text-align: right;
        margin: 0;
        
        .el-button {
          margin-left: 8px;
        }
      }
    }
  }
}

.user-package-switch-info {
  .package-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    h4 { margin: 0; }
  }
  .package-user-facts {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #dce9e2;
    border-radius: 8px;
    background: #f6fbf8;
  }
  .strategy-detail { margin-top: 12px; }
  .full-row { grid-column: 1 / -1; }
  .multiline { white-space: pre-wrap; line-height: 1.6; }
}
</style>
